import { useMutation } from '@tanstack/react-query';
import { schoolApi } from '../api/school.api';
import { useAuthStore } from '../store/auth.store';

export function RdvConnectionPrompt({ onLater, callbackFailed = false }: { onLater: () => void; callbackFailed?: boolean }) {
  const school = useAuthStore((s) => s.school);
  const connect = useMutation({
    mutationFn: () => schoolApi.startRdvPermisOauth({ redirectUri: `${window.location.origin}/requests` }),
    onSuccess: ({ authorizationUrl }) => window.location.assign(authorizationUrl),
  });
  return <div className="paywall-screen">
    <div className="paywall-screen__brand"><img src="/logo-permio-halloween.png" alt="Permio" className="sidebar__logo" />{school?.name && <span className="paywall-screen__school">{school.name}</span>}</div>
    <section className="paywall-screen__card">
      <h1 className="paywall-screen__title">Connectez votre compte RDVPermis</h1>
      <p className="paywall-screen__subtitle">Votre espace Permio est prêt. Reliez RDVPermis pour retrouver vos créneaux et préparer vos réservations.</p>
      {callbackFailed && <p role="alert">La connexion RDVPermis a été interrompue. Vous pouvez réessayer ou continuer dans Permio.</p>}
      {connect.isError && <p role="alert">La connexion n’a pas pu démarrer. Vous pouvez réessayer ou continuer dans Permio.</p>}
      <div className="paywall-screen__actions paywall-screen__actions--rdv">
      <button className="btn btn--primary" disabled={connect.isPending} onClick={() => connect.mutate()}>{connect.isPending ? 'Ouverture de RDVPermis…' : 'Connecter RDVPermis'}</button>
      <button className="paywall-screen__logout" disabled={connect.isPending} onClick={onLater}>Plus tard</button>
      </div>
      <p className="paywall-screen__subtitle">Vous pourrez également connecter RDVPermis depuis les réglages.</p>
    </section>
  </div>;
}
